/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.3.3",
  "gitBuildTime": "2026-03-23T14:51:10.886Z",
  "gitBuildVersion": "1.3.3",
  "gitCommitId": "631d702",
  "gitCommitIdFull": "631d702b4453c1938ff9899f31776cb1f3c6207f",
  "gitCommitTime": "2026-03-23T14:49:46.000Z",
  "version": "1.3.3-2026-03-23T14:49:46.000Z-(631d702)"
};
